export enum Role_Key {
  // 超级管理员key
  RoleKeyAdmin = 'admin',
  // 普通管理员key（可以修改不能删除）
  RoleKeyNormal = 'manager',
  // 系统管理员key（不能修改不能删除）
  RoleKeyManager = 'sys_manager',
  // 安全管理员key（不能修改不能删除）
  RoleKeySafe = 'safe',
  // 审计管理员key（不能修改不能删除）
  RoleKeyAudit = 'audit',
  // 自定义角色key（可以修改可以删除）
  RoleKeyCustom = 'custom',
}
